"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// USAGE:
// var httpLib = require('./http-library.js');
//
// var requestParams = {
//     host: HOST,
//     port:  PORT,
//     method: "GET",
//     path: 'PATH',
//     headers: {
//        'Authorization': 'Bearer '+config.internal_handshake_base64
//     },
// };
//
// var postBody = {boop: "beep"};
//
// httpLib.request(request_params, function(response) {
//     //do stuff with response
// }, postBody);

//EXAMPLE RESPONSE:
//Sucess:
// {
//    statusCode: 200,
//    listings: [{},{}]
// }
//Error:
// {
//    statusCode: 400,
//    error: 'invalid password'
// }

var http = require('http');
var _ = require('lodash');
var checkHeaders = function checkHeaders(headers, postBody) {
  var headersIfBody = {
    'Content-Type': 'application/json',
    'Content-Length': postBody ? postBody.length : 0
  };
  var headersDefault = {
    'Accept': 'application/json',
    'Cache-Control': 'no-cache, must-revalidate',
    'Pragma': 'no-cache'
  };
  return _.assign(postBody ? headersIfBody : headersDefault, headers);
};
exports.request = function (requestParams, callback, optionalBody) {
  console.log('API REQUEST', {
    path: requestParams.path
  });
  var methodToAssign = requestParams.method || 'GET';
  requestParams.method = methodToAssign;
  if (-1 === ["GET", "PUT", "POST", "DELETE"].indexOf(requestParams.method)) {
    throw new Error("requestParams.method value was " + requestParams.method + " , but must be one of 'GET', 'PUT', 'POST', 'DELETE'");
  }
  var postBody, unsanitizedBody;
  if (optionalBody) {
    try {
      unsanitizedBody = JSON.stringify(optionalBody);
      postBody = unsanitizedBody.replace(/(<([^>]+)>)/ig, "");
    } catch (e) {
      throw new Error("optionalBody was provided, but errored when stringified:", e);
    }
  }
  var requestHeaders = checkHeaders(requestParams.headers, postBody);
  var newReqParams = requestParams;
  var path = requestParams.path;
  newReqParams.headers = requestHeaders;
  newReqParams.timeout = 10000;
  if (-1 === path.indexOf('?')) {
    newReqParams.path = encodeURI(path + '?timestamp=' + Date.now());
  } else {
    newReqParams.path = encodeURI(path);
  }
  var request = http.request(newReqParams, function (response) {
    var responseString = '';
    response.on('data', function (d) {
      responseString += d;
    });
    response.on('end', function () {
      var responseObject = {};
      try {
        responseObject = JSON.parse(responseString);
        responseObject.statusCode = response.statusCode;
        var _path = newReqParams.path;
        if (399 < response.statusCode && 'object' === (typeof analyticsIntegrations === "undefined" ? "undefined" : _typeof(analyticsIntegrations))) {
          if (-1 === ['PUT', 'POST'].indexOf(newReqParams.method)) {
            analyticsIntegrations.formFail(_path, responseString);
          } else if ('GET' === newReqParams.method) {
            analyticsIntegrations.requestFail(_path, responseString);
          }
        }
      } catch (e) {
        responseObject = {
          error: 'Invalid JSON',
          responseData: responseString
        };
      }
      console.log('API RESPONSE RECEIVED', {
        path: requestParams.path
      });
      return callback(responseObject);
    });
  });
  request.on('error', function (e) {
    var path = requestParams.path;
    var method = newReqParams.method;
    var loggerObj = {
      path: path,
      method: method,
      error: e.message
    };
    console.warn('API ERROR', loggerObj);
    return callback({
      error: e.message
    });
  });
  request.on('timeout', function (e) {
    request.abort();
    var path = requestParams.path;
    var method = newReqParams.method;
    var loggerObj = {
      path: path,
      method: method
    };
    console.warn('API TIMEOUT', loggerObj);
  });
  if (postBody) {
    request.write(postBody);
  }
  request.end();
};